import { useQuery } from "@tanstack/react-query";
import { getAllTransactions } from "@/api/v1-jwt/transaction/transaction";
import { useAuth } from "@/providers/auth";

export const useTransactions = ({
  userId,
  enabled,
  queryKey,
  queryFn,
  ...config
} = {}) => {
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;
  const isEnabled = !!id && enabled !== false;

  return useQuery({
    queryKey: ["transactions"],
    queryFn: () => getAllTransactions(id),
    enabled: isEnabled,
    ...config,
  });
};
